import React from 'react';

import DismissablePromotionDone from 'app/developer-v3/components/AppBuilder/CTA/CTAs/DismissablePromotionDone';

type Props = {
  persistId: string;
  version: string;
};

function Done(props: Props) {
  const { persistId, version } = props;
  return <DismissablePromotionDone persistId={persistId} version={version} />;
}

export default Done;
